module.exports = __webpack_public_path__ + "img/blue_178.ec454931.png";